module.exports = __webpack_public_path__ + "static/mobileHero-e44fbf2fe4a53aa67036e9031a0ab515.png";